import { useMemo } from 'react';
import { queryOptions, useQuery } from '@tanstack/react-query';

import { fetchNavigationCustomization } from '../../api/portalGateway/navigationCustomization';
import { prependRoleId } from '../../utils/prependRoleId';

import styles from './navigationTooltip.module.scss';

const MAX_SUBLABELS = 4;

export function navigationCustomizationOptions() {
  return queryOptions({
    queryKey: prependRoleId(['navigationCustomization']),
    queryFn: fetchNavigationCustomization,
  });
}

export function useNavigationCustomizationQuery() {
  return useQuery(navigationCustomizationOptions());
}

export const useGetDynamicNavData = () => {
  const { data, isPending } = useQuery(navigationCustomizationOptions());

  return useMemo(() => {
    if (!data?.data?.dynamicNavigationItems) {
      return { isPending, navItems: [] };
    }

    const navItems = data.data.dynamicNavigationItems.map((item) => {
      const labels = item.navItemLabels;
      const label = labels?.[0]?.displayValue ?? '';
      const sublabels =
        labels != null && labels.length > 1
          ? labels.slice(1, 1 + MAX_SUBLABELS).map((s) => s.displayValue ?? '')
          : undefined;
      const tooltip =
        labels != null && labels.length > 1 ? (
          <>
            {labels.map((l, i) => (
              <div key={i} className={styles['label-row']}>
                {l.displayValue}
              </div>
            ))}
          </>
        ) : undefined;
      return {
        ...item,
        completeSlug: item.href,
        iconName: item.icon,
        label,
        sublabels,
        tooltip,
      };
    });

    return { isPending, navItems };
  }, [data, isPending]);
};
